import React, { forwardRef, useImperativeHandle } from 'react'
import StaigeButton from './Button'
import i18n from '../../languages/i18n'

import './Modal.scss'

type staigeModalPropTypes = {
  title?: string
  text?: string
  active?: boolean
  onConfirm?: (value?: string) => void
  disabledConfirm?: boolean
  onConfirmCloseModalDisable?: boolean
  confirmText?: string
  disableCancleBtn?: boolean
  closeOutsideClick?: boolean
  children?: any
}

type staigeModalStateTypes = {
  open: boolean
  confirmOption?: string
}

export interface StaigeModalRef {
  handleOpenModal: (value?: string) => void
  handleCloseModal: () => void
}

const StaigeModal = forwardRef<StaigeModalRef, staigeModalPropTypes>((props, ref) => {
  const [open, setOpen] = React.useState(false)
  const [confirmOption, setConfirmOption] = React.useState<string | undefined>(undefined)
  const wrapperRef = React.useRef<any>(null)

  React.useEffect(() => {
    if (props.closeOutsideClick) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      if (props.closeOutsideClick) {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [props.closeOutsideClick])

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      handleCloseModal()
    }
  }

  const handleOpenModal = (value?: string) => {
    setOpen(true)
    setConfirmOption(value)
  }

  const handleCloseModal = () => {
    setOpen(false)
    setConfirmOption(undefined)
  }

  const handleConfirm = async () => {
    if (props.onConfirm) {
      if (confirmOption) {
        props.onConfirm(confirmOption)
      } else {
        props.onConfirm()
      }
    }

    if (props.onConfirmCloseModalDisable) {
      return
    }

    handleCloseModal()
  }

  useImperativeHandle(ref, () => ({
    handleOpenModal,
    handleCloseModal
  }))

  const { title, text, confirmText, disableCancleBtn, children } = props

  if (!open) return null

  return (
    <div className={`staige-modal`}>
      <div className='modal-container' ref={wrapperRef}>
        <div className='container-inner'>
          <div className='inner-title'>{title ?? ' Title...'}</div>
          {text ? <div className='inner-text'>{text}</div> : null}
          {children ? <div className='inner-text'>{children}</div> : null}
        </div>
        <div className='container-action'>
          {disableCancleBtn ? null : (
            <StaigeButton style='ghost' label={i18n.t('general.cancel')} onClick={handleCloseModal} />
          )}
          <StaigeButton
            label={confirmText ?? i18n.t('general.confirm')}
            onClick={handleConfirm}
            disabled={props.disabledConfirm}
          />
        </div>
      </div>
    </div>
  )
})

StaigeModal.displayName = 'StaigeModal'

export default StaigeModal
